import { defineMessages } from 'react-intl';

export default defineMessages({
    emptyProject: {
        id: 'components.tree.emptyProject',
        defaultMessage: 'This project is empty',
    },
});
